

class CacheService {

	save(key, value, permanently) {
		try {
			if (permanently === true)
				localStorage.setItem(key, value);
			else
				sessionStorage.setItem(key, value);
		}catch(error) {
			//expected because localstorage and session storage does not work in some mobile
			console.log(error);
			
			this._saveInCookie(key, value);
		}
	}

	_saveInCookie(key, value) {
		try {
			//90days after
			const expirationTime = new Date(new Date().getTime() + (90 * 24 * 60 * 60 * 1000));

			//no expiration, so it will be deleted by default when browser closes
			document.cookie = key+"="+value+";path=/;expires="+expirationTime.toUTCString();
		} catch (error) {
			console.log("Cookie Error", error);
		}
	}

	get(key) {
		try {
			return localStorage.getItem(key) || sessionStorage.getItem(key);
		} catch (error) {
			//expected because localstorage and session storage does not work in some mobile
			console.log(error);
			return this._getFromCookie(key);
		}
	}

	getAllKeys() {
		return Object.keys(localStorage).concat(Object.keys(sessionStorage));
	}

	_getFromCookie(key){
		try{
			const cookieVal = document.cookie.split(";").filter(v => v.split("=")[0].trim() === key);
			
			if(cookieVal && cookieVal.length > 0) {
				return cookieVal[0].split(key+"=")[1];
			}

			return null;
		} catch(error) {
			console.log("Cookie Error", error);
			return null;
		}
	}

	remove(key){
		try {
			localStorage.removeItem(key);
			sessionStorage.removeItem(key);
		} catch (error){
			//expected because localstorage and session storage does not work in some mobile
			console.log(error);
			this._removeFromCookie(key);
		}
	}

	_removeFromCookie(key) {
		try{
			document.cookie = key+"=;expires=Thu, 01 Jan 1970 00:00:00 UTC;"
		} catch(error) {
			console.log("Cookie Error", error);
		}
	}
}

export default new CacheService();


// WEBPACK FOOTER //
// ./src/service/CacheService.js